import React, { useEffect, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    CardActionArea,
    CardContent,
    Chip,
    CircularProgress,
    Grid,
    InputAdornment,
    OutlinedInput,
    Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { IconSearch, IconPlus, IconRobot, IconSettings, IconHeadset, IconUser, IconPlugConnected } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import api from '../../../../services/api';

const hostname = window.location.hostname;
let AGENT_SERVER;

if (hostname.startsWith('crm.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('glazzbeauty.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('casamathiola.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('bliveinpets.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('acin.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('braza55.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('po.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('florestavet.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('quimicer.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('imobiliaria.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else {
    AGENT_SERVER = 'http://127.0.0.1:7000';
}

// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'https://apichat.loged.com.br';

const agentApi = axios.create({ baseURL: AGENT_SERVER });
agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

const AGENT_TYPES = {
    client_chatbot: {
        label: 'Chatbot Cliente Externo',
        color: '#1565c0',
        bg: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
        border: '#90caf9',
        Icon: IconRobot
    },
    admin_chatbot: {
        label: 'Chatbot Administrador',
        color: '#6a1b9a',
        bg: 'linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)',
        border: '#ce93d8',
        Icon: IconUser
    },
    attendant_chatbot: {
        label: 'Chatbot Atendente',
        color: '#00695c',
        bg: 'linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%)',
        border: '#80cbc4',
        Icon: IconHeadset
    },
    system: {
        label: 'Agente de Sistema',
        color: '#bf360c',
        bg: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
        border: '#ffcc80',
        Icon: IconSettings
    }
};

const useStyles = makeStyles((theme) => ({
    searchControl: {
        width: '360px',
        background: '#fff',
        color: 'text.primary',
        [theme.breakpoints.down('md')]: { width: '100%' }
    }
}));

const ViewAgents = () => {
    const [agents, setAgents] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [canais, setCanais] = useState([]);

    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        carregarAgentes();
    }, []);

    useEffect(() => {
        if (!search.trim()) {
            setFiltered(agents);
        } else {
            const term = search.toLowerCase();
            setFiltered(agents.filter((a) => a.name.toLowerCase().includes(term) || a.agent_type.toLowerCase().includes(term)));
        }
    }, [search, agents]);

    const carregarAgentes = async () => {
        setLoading(true);
        try {
            const appResponse = await api.get('v1/apps/default/');
            const appId = appResponse.data?.app?.id;
            const accountId = appResponse.data?.app?.account;

            if (!appId || !accountId) {
                setStatus({ type: 'error', message: 'Não foi possível obter as informações do app.' });
                return;
            }

            console.log(`carregarAgentes - accountId: ${accountId}`);
            console.log(`carregarAgentes - appId: ${appId}`);

            const agentsResponse = await agentApi.get(`/agent/api/v1/account/${accountId}/app/${appId}/agents/`);
            const data = agentsResponse.data?.agents || [];
            setAgents(data);
            setFiltered(data);

            const integrationsResponse = await api.get(`v1/apps/${appId}/integrations/`);
            setCanais(integrationsResponse.data?.integrations || []);
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao carregar agentes.' });
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (iso) => {
        if (!iso) return '—';
        return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    return (
        <Box>
            {/* HEADER */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                <Box>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            background: 'linear-gradient(90deg, #1976d2, #9c27b0)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            lineHeight: 1.2
                        }}
                    >
                        Agentes de IA
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                        Gerencie assistentes e chatbots do sistema
                    </Typography>
                </Box>

                <Button
                    variant="contained"
                    startIcon={<IconPlus size={18} />}
                    onClick={() => history.push('/dashboard/config/agents/create')}
                    sx={{
                        borderRadius: '12px',
                        px: 3,
                        py: 1.2,
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: '0.9rem',
                        background: 'linear-gradient(135deg, #1976d2, #9c27b0)',
                        boxShadow: '0 8px 20px rgba(25,118,210,0.3)',
                        transition: 'all 0.3s',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: '0 12px 25px rgba(25,118,210,0.45)'
                        }
                    }}
                >
                    Criar Agente
                </Button>
            </Box>

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 3, borderRadius: '12px' }}>
                    {status.message}
                </Alert>
            )}

            {/* BUSCA */}
            <OutlinedInput
                className={classes.searchControl}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Buscar agente..."
                sx={{ borderRadius: '12px', color: 'text.primary', mb: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                startAdornment={
                    <InputAdornment position="start">
                        <IconSearch size="1.2rem" color="#999" />
                    </InputAdornment>
                }
            />

            {/* CONTEÚDO */}
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
                    <CircularProgress size={48} />
                </Box>
            ) : filtered.length === 0 ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 10,
                        color: 'text.secondary',
                        background: 'linear-gradient(135deg, #f8f9ff, #f0f4ff)',
                        borderRadius: '16px',
                        border: '2px dashed #c5cae9'
                    }}
                >
                    <IconRobot size={56} color="#9fa8da" style={{ marginBottom: 12 }} />
                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#5c6bc0', mb: 1 }}>
                        Nenhum agente encontrado
                    </Typography>
                    <Typography variant="body2">Crie seu primeiro agente clicando em "Criar Agente"</Typography>
                </Box>
            ) : (
                <Grid container spacing={3}>
                    {filtered.map((agent) => {
                        const typeConfig = AGENT_TYPES[agent.agent_type] || {
                            label: agent.agent_type,
                            color: '#455a64',
                            bg: 'linear-gradient(135deg, #eceff1, #cfd8dc)',
                            border: '#b0bec5',
                            Icon: IconRobot
                        };
                        const AgentIcon = typeConfig.Icon;

                        const qtdCanais = canais.filter((c) => String(c.webhook_agent_id || '') === String(agent.id)).length;

                        return (
                            <Grid item xs={12} sm={6} lg={4} key={agent.id}>
                                <Card
                                    sx={{
                                        borderRadius: '16px',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
                                        border: `1px solid ${typeConfig.border}`,
                                        height: '100%',
                                        transition: 'all 0.25s ease',
                                        '&:hover': {
                                            transform: 'translateY(-4px)',
                                            boxShadow: '0 12px 32px rgba(0,0,0,0.12)'
                                        }
                                    }}
                                >
                                    <CardActionArea
                                        onClick={() => history.push(`/dashboard/config/detailagent/${agent.id}`)}
                                        sx={{ height: '100%', p: 0, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                                    >
                                        {/* TOP COLORED BAND */}
                                        <Box
                                            sx={{
                                                background: typeConfig.bg,
                                                px: 2.5,
                                                pt: 2.5,
                                                pb: 1.5,
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: 2
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: 48,
                                                    height: 48,
                                                    borderRadius: '12px',
                                                    background: '#fff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: `0 4px 12px ${typeConfig.border}`,
                                                    flexShrink: 0
                                                }}
                                            >
                                                <AgentIcon size={26} color={typeConfig.color} />
                                            </Box>

                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        fontWeight: 700,
                                                        color: '#1a1a2e',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        mb: 0.5
                                                    }}
                                                >
                                                    {agent.name}
                                                </Typography>
                                                <Chip
                                                    label={typeConfig.label}
                                                    size="small"
                                                    sx={{
                                                        backgroundColor: '#fff',
                                                        color: typeConfig.color,
                                                        fontWeight: 600,
                                                        fontSize: '0.7rem',
                                                        border: `1px solid ${typeConfig.border}`,
                                                        height: 22
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                        <CardContent sx={{ pt: 1.5, pb: '16px !important', flex: 1 }}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: 'text.secondary',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    lineHeight: 1.6,
                                                    minHeight: 72,
                                                    mb: 2
                                                }}
                                            >
                                                {agent.system_prompt || 'Sem prompt configurado.'}
                                            </Typography>

                                            <Chip
                                                icon={<IconPlugConnected size={14} />}
                                                label={qtdCanais > 0 ? `${qtdCanais} canal(is) atendido(s)` : 'Nenhum canal atribuído'}
                                                size="small"
                                                sx={{
                                                    mb: 1.5,
                                                    fontWeight: 600,
                                                    fontSize: '0.7rem',
                                                    color: qtdCanais > 0 ? '#1565c0' : 'text.secondary',
                                                    backgroundColor: qtdCanais > 0 ? '#e3f2fd' : '#f0f0f0'
                                                }}
                                            />

                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="caption" sx={{ color: '#bdbdbd' }}>
                                                    Criado em {formatDate(agent.created_at)}
                                                </Typography>
                                                <Typography variant="caption" sx={{ color: typeConfig.color, fontWeight: 600 }}>
                                                    Ver ferramentas →
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            )}
        </Box>
    );
};

export default ViewAgents;
